import { SelectChangeEvent, SxProps, Theme } from '@mui/material';
import { GammaLevels } from 'components/indices/charts';
import { ExpandableContentWrapper } from 'components/shared';
import { CanvasContentId } from 'types/canvas';
import { IndicesContentType } from 'types/indices';
import { getDefaultSymOptions } from 'util/indices';
import { CanvasGroupLinkButton } from 'components/canvas/groups';

interface CanvasGammaLevelsProps {
  id: number;
  sym: string;
  onSymChange: (sym: string) => void;
}

const CanvasGammaLevels = ({
  id,
  sym,
  onSymChange,
}: CanvasGammaLevelsProps) => {
  const handleSymChange = (event: SelectChangeEvent<string>) => {
    const sym = event.target.value;
    onSymChange(sym ?? 'SPX');
  };

  const containerStyleOverrides: SxProps<Theme> = {
    height: '95%',
  };

  return (
    <ExpandableContentWrapper type={IndicesContentType.GAMMA_LEVELS}>
      <GammaLevels
        containerStyleOverrides={containerStyleOverrides}
        selectedSym={sym}
        symSelectorSettings={{
          value: sym,
          options: getDefaultSymOptions(IndicesContentType.GAMMA_LEVELS),
          onChange: handleSymChange,
        }}
        headerExtras={
          <CanvasGroupLinkButton
            componentId={id}
            contentId={CanvasContentId.GAMMA_LEVELS_CHART}
          />
        }
      />
    </ExpandableContentWrapper>
  );
};

export default CanvasGammaLevels;
